export const getMessageBlocks = htmlContent => {
  if (!htmlContent) return []; // Important: Return an empty array, not a string

  // Parse HTML string into real DOM
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  // Get direct children of body (p, ul, h3, etc.)
  // Array.from is important to make it iterable
  const nodes = Array.from(doc.body.childNodes);

  // Convert to HTML strings
  return nodes
    .filter(node => {
      // We want elements (type 1) or non-empty text (type 3)
      return (
        node.nodeType === 1 || (node.nodeType === 3 && node.textContent.trim())
      );
    })
    .map(node => {
      // For elements (e.g. <ul>) we take the complete HTML including children
      return node.nodeType === 1 ? node.outerHTML : node.textContent;
    });
};

/**
 * Analyzes an HTML block and extracts list items (<li>) from it.
 * @param {string} htmlBlock - The complete HTML string of a block (e.g. "<ul><li>A</li><li>B</li></ul>")
 * @returns {Array<string>|null} Array with inner HTML of list items, or null if it's not a list.
 */
export const getNestedContent = htmlBlock => {
  if (
    !htmlBlock ||
    (!htmlBlock.startsWith("<ul") && !htmlBlock.startsWith("<ol"))
  ) {
    return null;
  }

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlBlock, "text/html");

    // The first child of <body> is the block (<ul> or <ol>)
    const rootElement = doc.body.firstElementChild;

    if (
      !rootElement ||
      (rootElement.tagName !== "UL" && rootElement.tagName !== "OL")
    ) {
      return null;
    }

    // We return the inner content of the <li> elements.
    return Array.from(rootElement.children).map(child => child.innerHTML);
  } catch (error) {
    return null;
  }
};
